module.exports = __webpack_public_path__ + "img/375_stores_img4.cf8f261d.png";